import { TourAnchor } from "training/anchors";
import { ITourFollowUp } from "training/types";

/**
 * CLE-3015 — pieces Modules 3–6 share.
 *
 * Since the Estimate Details redesign (CLE-2961, after the curriculum was checked) the page's actions —
 * Collect Payment, Mark paid, Download PDF / ABN, Duplicate, Cancel — sit in a "..." menu at the top
 * right, not in a row of buttons; only "Redo Estimate" is still a button. Every step on a menu item
 * carries this `opener`, so the engine first has the trainee open the menu (`<id>-open`).
 *
 * Not curriculum text: the curriculum predates the menu.
 */
export const ESTIMATE_ACTIONS_MENU: ITourFollowUp = {
  anchor: TourAnchor.EstimateActions,
  label: "Estimate actions",
  text: 'Open the "..." menu at the top right of the estimate.',
};

/** The first time the menu is opened (3.8), the opener says what is in it. Not curriculum text. */
export const ESTIMATE_ACTIONS_MENU_FIRST: ITourFollowUp = {
  ...ESTIMATE_ACTIONS_MENU,
  text: 'The rest of this estimate\'s actions are in the "..." menu at the top right: Collect Payment, Download PDF, Duplicate, Cancel and more. Open it.',
};
